import { getAuthToken } from '@anm/auth/helpers/authToken';

var getAuthHeaders = function getAuthHeaders() {
  var token = getAuthToken();
  if (!token) return;
  var requestHeaders = {
    headers: {
      'Animatron-Security-Token': token
    }
  };
  return requestHeaders;
};

export default getAuthHeaders;